/**
 * Such-Dialog im Header: Lupe öffnet ein kleines modales Fenster mit Suchfeld.
 * Markup (<button> + <dialog>) liegt im ungefilterten HTML-Element des Headers;
 * Escape schließt nativ (Polyfill in polyfills/dialog.js), Klick auf den
 * Hintergrund und der Schließen-Button hier.
 */

import { get, onDomReady } from '../utils/dom';

onDomReady(() => {
    const button = get('.header-search');
    const dialog = get('#search-dialog');

    if (!button || !dialog) {
        return;
    }

    const input = dialog.querySelector('input[type="search"]');
    const inside = dialog.querySelector('.easy-popup-inside');
    const close = () => dialog.close();

    button.addEventListener('click', () => {
        dialog.showModal();
        input?.focus();
    });

    dialog.querySelector('.overlay-close')?.addEventListener('click', close);

    // Klick außerhalb des weißen Fensters (auf die Fläche .easy-popup-inside) schließt
    inside?.addEventListener('click', (event) => {
        if (event.target === inside) {
            close();
        }
    });
});
